import React, {useState, useEffect,useCallback }  from "react";
import './home.scss'
import Axios from 'axios'
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import WidgetWalk from '../Charts/widget/WidgetWalk';
import WidgetCall from '../Charts/widget/WidgetCall';
import WidgetOnline from '../Charts/widget/WidgetOnline';
import WidgetWalkon from '../Charts/widget/WidgetWalkon';
import Feature from '../Charts/feature/Feature'
import Chart from '../Charts/chart/Chart'
const Swal = require('sweetalert2');
export const Home = () => {
  
  useEffect(() => {
    const token = localStorage.getItem('token')
    fetch('http://27.254.66.164:5000/Author',{
    method: 'POST',
    mode: 'cors',
    headers: {
        'Authorization': 'Bearer '+token,
        'Content-Type': 'application/json',
    },
})
.then(response => response.json())
.then(data => {
        if (data.status === 'ok'){
        } else {
          Swal.fire({
            title: 'กรุณาเข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง',
          }).then((result) => {
            if (result.isConfirmed) { 
              window.location.href = '/ec-crm/Login'
            }
          })
        }
    });
},[])
 /* const  now = new Date()
  let firstDay = (new Date(now.getFullYear(), now.getMonth(), 1)).toLocaleDateString("en-CA");
  let lastDay= (new Date(now.getFullYear(), now.getMonth() + 1, 0)).toLocaleDateString("en-CA");
  const [Firstdate, setFirstdate] = useState(firstDay);
  const [Enddate, setEnddate] = useState(lastDay);*/

  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().substring(0, 10);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().substring(0, 10);
  const [Firstdate, setFirstdate] = useState(firstDay);
  const [Enddate, setEnddate] = useState(lastDay);

  const [EmployeeType, setEmployeeType] = useState("");
  const [EmpId, setEmpId] = useState("");
  useEffect(() => {
    const EmployeeType = JSON.parse(localStorage.getItem('EmployeeType'));
    if (EmployeeType) {
      setEmployeeType(EmployeeType);
     }
  },[setEmployeeType]);
  useEffect(() => {
    const EmpId = JSON.parse(localStorage.getItem('EmpId'));
    if (EmpId) {
      setEmpId(EmpId);
     }
  },[setEmpId]);
  const [ProjectId, setProjectId] = useState("%");
  const [LableProjectList, setLableProjectList] = useState([]);
  const [ProjectList, setProjectList] = useState([]);
  const [Walk, setWalk] = useState([]);
  const [Call, setCall] = useState([]);
  const [Online, setOnline] = useState([]);
  const [Walkon, setWalkon] = useState([]);
  const [WalkList, setWalkList] = useState([]);
  const [CallList, setCallList] = useState([]);
  const [OnlineList, setOnlineList] = useState([]);
  const [WalkonList, setWalkonList] = useState([]);
  const [RsList, setRsList] = useState([]);
  const [RcList, setRcList] = useState([]);
  const [ChartList, setChartList] = useState([]);
  const [AllList, setAllList] = useState([]);
  useEffect(() => {
    Axios.post('http://27.254.66.164:5000/projectserch',{
      EmployeeType:EmployeeType,
      EmpId:EmpId
    }).then((response) => {
      setProjectList(response.data);
    });
  }, [EmployeeType,EmpId]);
  const serch = useCallback(() => {
    Axios.post('http://27.254.66.164:5000/Chart', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      EmpId:EmpId,
      EmployeeType: EmployeeType,
      ProjectId: ProjectId
    }).then((response) => {
      setChartList(response.data);
    });
    Axios.post('http://27.254.66.164:5000/lableProject', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      EmpId:EmpId,
      EmployeeType: EmployeeType,
      ProjectId: ProjectId
    }).then((response) => {
      setLableProjectList(response.data);
    });
    Axios.post('http://27.254.66.164:5000/WalkSerch', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      EmpId:EmpId,
      EmployeeType: EmployeeType,
      ProjectId: ProjectId
    }).then((response) => {
      setWalkList(response.data);
    });
    Axios.post('http://27.254.66.164:5000/CallSerch', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      EmpId:EmpId,
      EmployeeType: EmployeeType,
      ProjectId: ProjectId
    }).then((response) => {
      setCallList(response.data);
    });
    Axios.post('http://27.254.66.164:5000/onlineSerch', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      EmpId:EmpId,
      EmployeeType: EmployeeType,
      ProjectId: ProjectId
    }).then((response) => {
      setOnlineList(response.data);
    });
    Axios.post('http://27.254.66.164:5000/WalkonSerch', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      EmpId:EmpId,
      EmployeeType: EmployeeType,
      ProjectId: ProjectId
    }).then((response) => {
      setWalkonList(response.data);
    });
    Axios.post('http://27.254.66.164:5000/RsSerch', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      EmpId:EmpId,
      EmployeeType: EmployeeType,
      ProjectId: ProjectId
    }).then((response) => {
      setRsList(response.data);
    });
    Axios.post('http://27.254.66.164:5000/RcSerch', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      EmpId:EmpId,
      EmployeeType: EmployeeType,
      ProjectId: ProjectId
    }).then((response) => {
      setRcList(response.data);
    });
    Axios.post('http://27.254.66.164:5000/Walk', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      EmpId:EmpId,
      EmployeeType: EmployeeType,
      ProjectId: ProjectId
      }).then((response) => {
          setWalk(response.data);
      });
      Axios.post('http://27.254.66.164:5000/Call', {
        Firstdate: Firstdate,
        Enddate: Enddate,
        EmpId:EmpId,
        EmployeeType: EmployeeType,
        ProjectId: ProjectId
      }).then((response) => {
          setCall(response.data);
      });
      Axios.post('http://27.254.66.164:5000/online', {
        Firstdate: Firstdate,
        Enddate: Enddate,
        EmpId:EmpId,
        EmployeeType: EmployeeType,
        ProjectId: ProjectId
      }).then((response) => {
          setOnline(response.data);
      });
      Axios.post('http://27.254.66.164:5000/Walkon', {
        Firstdate: Firstdate,
        Enddate: Enddate,
        EmpId:EmpId,
        EmployeeType: EmployeeType,
        ProjectId: ProjectId
      }).then((response) => {
          setWalkon(response.data);
      });
      Axios.post('http://27.254.66.164:5000/All', {
        Firstdate: Firstdate,
        Enddate: Enddate,
        EmpId:EmpId,
        EmployeeType: EmployeeType,
        ProjectId: ProjectId
      }).then((response) => {
          setAllList(response.data);
      });
    }, [ProjectId,EmployeeType,EmpId,Enddate,Firstdate]);
    useEffect(() => {
      serch();
    },[serch]);
  /*const onSetFirstDate = (event) => {
    setFirstdate((new Date(event.target.value)).toLocaleDateString("en-CA"))
  }
  const onSetEndDate = (event) => {
    setEnddate((new Date(event.target.value)).toLocaleDateString("en-CA"))
  }*/

  const onSetFirstDate = (event) => {
    setFirstdate(new Date(event.target.value).toISOString().substring(0, 10))
  }
  
  const onSetEndDate = (event) => {
    setEnddate(new Date(event.target.value).toISOString().substring(0, 10))
  }

  const onSetProject = (event) => {
    setProjectId(event.target.value)
  }
  return (
    <div className="home">
        <div className="homeContainer">
        <br></br>
          <form align="center">  
            <div className="row justify-content-md-center">  
                <div className="col col-lg-3" >
                    <div className="input-group">
                      <span className="input-group-text"><HolidayVillageIcon /></span>
                      <select className='form-control' value={ProjectId} multiple={false} onChange={onSetProject}>
                            <option value="%">ทั้งหมด</option>
                                {
                                  ProjectList.map( (x,key) => 
                                  <option key={key} value={x.ProjectId}>{ x.ProjectShortName+" : "+x.ProjectName}</option> )
                                }
                      </select>
                    </div>
                </div>  
                <div className="col col-lg-3" >
                  <div className="input-group">
                      <span className="input-group-text"><TodayIcon /></span>
                      <input type="date" className='form-control' value={Firstdate} onChange={onSetFirstDate} data-date-end-date="0d"/>
                  </div>
                </div>  
                <div className="col col-lg-3">
                  <div className="input-group">
                      <span className="input-group-text"><CalendarMonthIcon /></span>
                      <input type="date" className='form-control' value={Enddate} onChange={onSetEndDate} data-date-end-date="0d"/>
                  </div>
                </div>
                
            </div>  
          </form>  
          <div className='widgets'>
            <WidgetWalk Walk={Walk} AllList={AllList}/>
            <WidgetCall Call={Call} AllList={AllList}/>
            <WidgetOnline Online={Online} AllList={AllList}/>
            <WidgetWalkon Walkon={Walkon} AllList={AllList}/>
          </div>
          <div className="charts">
            <Feature ChartList={ChartList}/>
            <Chart LableProjectList={LableProjectList} WalkList={WalkList} CallList={CallList} OnlineList={OnlineList} WalkonList={WalkonList} RsList={RsList} RcList={RcList}/>
          </div>
        </div>
    </div>
  )
}



